// extracted by mini-css-extract-plugin
export default {"title":"_ceed1ed3","itemContainer":"_3b3f4401","shimmerLoadingBackground":"_668562de"};